import {AppState} from '../../configStore';

export const selectCurrentAddressKey = (state: AppState) => state.currentAddressKey;
